import './color-input.scss'
import {
  HexAlphaColorPicker,
  HexColorInput,
  HexColorPicker,
} from 'react-colorful'
import { useRef, useState } from 'react'
import clsx from 'clsx'
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'

const ColorInput = ({
  value,
  icon,
  label,
  onChange,
  onSubmit = () => {},
  containerRef,
  containerClass,
  isLocked,
  hideInput,
  hideColorPreview,
  hideClear,
  onUnlock,
  tooltip,
  alpha = false,
}) => {
  const ref = useRef()
  const [pickerOpen, setPickerOpen] = useState(false)
  const [originalColor, setOriginalColor] = useState(value)
  const inputPlaceholder = isLocked ? 'mixed' : ''
  const inputDisabled = isLocked
  const inputValue = value === null ? '' : value
  const pickerPosition = {}
  const pickerButtonStyle = {}
  if (!hideColorPreview) {
    pickerButtonStyle.backgroundColor = value
    pickerButtonStyle.boxShadow = '0 0 1px #bababa'
    pickerButtonStyle.border = '1px solid #78787B'
  }

  if (containerRef?.current && ref.current) {
    const containerRect = containerRef.current.getBoundingClientRect()
    const rect = ref.current.getBoundingClientRect()
    const width = containerRect.width
    const height = containerRect.height
    const offsetLeft = rect.left - containerRect.left
    const offsetTop = rect.top - containerRect.top

    if (offsetLeft > width / 2) {
      pickerPosition.right = 0
    } else {
      pickerPosition.left = 0
    }

    if (offsetTop > height / 2) {
      pickerPosition.bottom = '-50px'
    } else {
      pickerPosition.top = '100%'
    }
  }

  function openPicker() {
    if (pickerOpen) {
      handleOk()
    } else {
      setOriginalColor(value)
      setPickerOpen(true)
    }
  }

  function handleCancel() {
    onChange(originalColor)
    setPickerOpen(false)
    onSubmit(originalColor)
  }

  function handleOk() {
    setPickerOpen(false)
    onSubmit(value)
  }

  function handleClear() {
    onChange('')
    setPickerOpen(false)
    onSubmit(originalColor)
  }

  return (
    <div className={clsx('color-input', containerClass)} ref={ref}>
      {label && <label>{label}</label>}
      <div className="flex">
        {!hideInput && (
          <div
            className={clsx('input', { 'flex-fill': isLocked })}
            data-tooltip={tooltip}
          >
            <HexColorInput
              color={inputValue}
              onChange={onChange}
              placeholder={inputPlaceholder}
              disabled={inputDisabled}
            />
            {isLocked && (
              <div className="absolute top-0 right-0 ">
                <button
                  className="bg-gray-light b-0 border-0 h-[36px] w-[35px] flex items-center justify-center rounded-r"
                  onClick={onUnlock}
                >
                  <EditIcon height="20" width="20" fill="#ccc" />
                </button>
              </div>
            )}
          </div>
        )}

        {!isLocked && (
          <div className={clsx('flex items-center', { 'ml-2': !hideInput })}>
            <button
              className="picker-button"
              data-tooltip={tooltip}
              style={pickerButtonStyle}
              onClick={openPicker}
            >
              {icon ? icon : null}
            </button>
          </div>
        )}
      </div>
      {pickerOpen && (
        <div className="picker" style={pickerPosition}>
          {alpha ? (
            <HexAlphaColorPicker color={value || ''} onChange={onChange} />
          ) : (
            <HexColorPicker color={value || ''} onChange={onChange} />
          )}

          {hideInput && (
            <div className={clsx('input ', { 'flex-fill': isLocked })}>
              <HexColorInput
                color={inputValue}
                onChange={onChange}
                placeholder={inputPlaceholder}
                disabled={inputDisabled}
                alpha={alpha}
              />
              {isLocked && (
                <div className="absolute top-0 right-0 ">
                  <button
                    className="bg-gray-light b-0 border-0 h-[36px] w-[35px] flex items-center justify-center rounded-r"
                    onClick={onUnlock}
                  >
                    <EditIcon height="20" width="20" fill="#ccc" />
                  </button>
                </div>
              )}
            </div>
          )}

          <div className="flex row p-2 my-2">
            <div className="flex-fill flex items-center">
              {!hideClear && (
                <button
                  className="py-2 px-4 font-bold text-sm text-white-dark"
                  onClick={handleClear}
                >
                  Clear
                </button>
              )}
            </div>
            <button
              className="py-2 px-4 font-bold text-sm"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              className="ml-2 py-2 px-8 bg-pink rounded font-bold text-sm"
              onClick={handleOk}
            >
              Ok
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default ColorInput
